import { render } from "./Programs.vue?vue&type=template&id=c472ff7a&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import "./Programs.vue?vue&type=style&index=0&id=c472ff7a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c472ff7a"]])

export default __exports__